const appProps = {
  welcomeShown: false,
  sidebarTab: undefined,
  isAnonymous: undefined,
  tenant: undefined,
  // The workflow slug of the public form on screen; anonymous lookups are scoped to it.
  anonymousSlug: undefined,
  sidebarExpanded: true,
  navbarContent: undefined,
  newReqDomElement: undefined,
};

export default appProps;
